export function helpers() {
	/* Copyright year */
	const d = new Date();
	const copyRightYr = d.getFullYear();
	document.getElementById('copyright-year').innerHTML = copyRightYr;

	/* New window to external link */
	document.querySelectorAll('a[href^="http"][target=_blank]').forEach(function (e) {
		e.setAttribute('rel', 'nofollow noreferrer');
	});

}